export default {
  ajaxing: false,
  deviceId: null,

  appMenu: false,
  appMessage: false,
  snackbars: [],

  logoutTag: 0,

  path: '/',
  roles: [],
  menus: [],
  pages: [],

  user: null,
  csrfToken: null,

  mqtt: {},
  mqttFailed: false,
  mqttTopics: [],
  mqttMessages: [],

  messages: 0,

  previewFiles: [],
}
